import { useTranslation } from 'react-i18next';
import IcShield from '@/assets/icons/Shield.svg?react';
import styles from './WhyItMatters.module.scss';

/**
 * Blue "No anonymous senders. Ever." panel shown beside the WebID prep step.
 *
 * The "Watch the 60-second intro by webID" link from the mockup is intentionally
 * omitted until we have the real video URL — drop it in here (a styled <a> with
 * a play glyph) once provided.
 */
const WhyItMatters = () => {
  const { t } = useTranslation(['onboarding']);

  return (
    <section className={styles.panel}>
      <span className={styles.eyebrow}>
        <IcShield className={styles.eyebrowIcon} aria-hidden="true" />
        {t('onboarding:kycRedesign.whyItMatters.eyebrow')}
      </span>
      <h2 className={styles.title}>
        {t('onboarding:kycRedesign.whyItMatters.title')}
      </h2>
      <blockquote className={styles.quote}>
        {t('onboarding:kycRedesign.whyItMatters.quote')}
      </blockquote>
      <p className={styles.subtitle}>
        {t('onboarding:kycRedesign.whyItMatters.subtitle')}
      </p>
    </section>
  );
};

export default WhyItMatters;
